<div class="clearfix">
  <div *ngIf="isAuthorised" class="flex justify-end align-center mt2 mb2">
    <button class="m-r-10" mat-raised-button [color]="'accent'" [routerLink]="clmRoutes.AddPharmacyCase">
      <mat-icon>add</mat-icon>
      ADD Pharmacy CASE
    </button>
    <button class="m-r-10" mat-raised-button [color]="'accent'" [routerLink]="clmRoutes.AddHospitalCase">
      <mat-icon>add</mat-icon>
      ADD HOSPITAL CASE
    </button>
    <button mat-raised-button [color]="'accent'" [routerLink]="clmRoutes.AddFuneralCase">
      <mat-icon>add</mat-icon>
      ADD FUNERAL CASE
    </button>
  </div>
</div>

<div class="header-container">
  <div class="header-spacer">
    <mat-grid-list cols="5" rowHeight="80px">
      <mat-grid-tile>
        <mat-form-field
          [style.width]="caseSearchNameFormControl.value ? '10vw' : '11vw'">
          <mat-label>Search Cases</mat-label>
          <input matInput type='text'
                 [formControl]="caseSearchNameFormControl"
                 (input)="onInputChangedSearchCase($event)">
        </mat-form-field>
        <button *ngIf="caseSearchNameFormControl.value"
                class="close-icon"
                (click)="clearSearchCasesFilter()">
          <mat-icon>close</mat-icon>
        </button>
        <mat-icon
          [matTooltip]="'Search by member ID number, member last name, membership number, case name or a comma-seperated list of case IDs'"
          class="info-icon">
          help_outline
        </mat-icon>
      </mat-grid-tile>
      
      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Processing Class</mat-label>
          <mat-select [id]="selectDropdownFilterName.PROCESSING_CLASS_BY_PROCESSING_ClASS_ID"
                      [formControl]="processingClassFormControl"
                      (selectionChange)="onProcessingClassSelectionChanged($event.source.value)">
            <mat-option *ngFor="let processingClass of processingClassLookupValues" [value]="processingClass.name">
              {{ processingClass.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
      
      <mat-grid-tile>
        <app-element-select displayLabel='Sub-Class'
                            [defaultValue]="selectedProcessingSubClass"
                            [disabled]="disabledProcessingSubClass()"
                            [options]="processingSubClassesOptions"
                            (selectionChanged)="onProcessingSubClassSelectionChanged($event)">
        </app-element-select>
      </mat-grid-tile>
      
      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Case Status</mat-label>
          <mat-select [id]="selectDropdownFilterName.CASE_STATUS"
                      [formControl]="caseStatusFormControl"
                      (selectionChange)="onCaseStatusSelectionChanged($event.source.value)">
            <mat-option *ngFor="let status of caseStatusLookupValues" [value]="status.name">
              {{ status.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
      
      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Case Manager</mat-label>
          <mat-select [id]="selectDropdownFilterName.CASE_MANAGER"
                      [formControl]="caseManagerFormControl"
                      (selectionChange)="onCaseManagerSelectionChanged($event.source.value)">
            <mat-option *ngFor="let manager of caseManagerLookupValues" [value]="manager.name">
              {{ manager.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
</div>

<div class="mat-elevation-z8 table-container">
  <table mat-table multiTemplateDataRows [dataSource]="casedTableDataSource"
         matSort (matSortChange)="sortData($event)">
    <ng-container [matColumnDef]="tableColumns.Icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        <span class="table-icon-container">
        <mat-icon class="table-icon font-medium" matTooltip="EDIT Case"
                  (click)="editEntry($event, row)"
                  [ngClass]="{'disabled': !row.processingClass?.name}">edit
        </mat-icon>
        <mat-icon class="table-icon font-medium" matTooltip="DELETE Case"
                  (click)="deleteCaseConfirmation($event, row.caseId)">delete
        </mat-icon>
        <mat-icon class="table-icon font-medium" matTooltip="DOWNLOAD Report"
                  (click)="generateCaseReport($event, row.caseId, row.processingClass?.name)">arrow_downward
        </mat-icon>
        </span>
      </td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.CaseId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header style="width: 7%;">Case Number</th>
      <td *matCellDef="let row" mat-cell> {{ row.caseId }}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.ProcessingClass">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Class</th>
      <td *matCellDef="let row" mat-cell> {{ row.processingClass?.name }}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.Name">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Case Name</th>
      <td *matCellDef="let row" mat-cell
          [matTooltip]="row.name">
        {{ row.name | truncateText: {sliceEnd: 65} }}
      </td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.StartDate">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
      <td *matCellDef="let row" mat-cell> {{ row.startDate | date: dateFormat }}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.InsuredPerson">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Member</th>
      <td *matCellDef="let row" mat-cell>
        <app-death-status-icon [personId]="row.insuredPerson.insuredPersonId"></app-death-status-icon>
        {{ row.insuredPerson?.firstName + ' ' + row.insuredPerson?.lastName }}
      </td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.CaseStatus">
      <th *matHeaderCellDef mat-header-cell> Case Status</th>
      <td *matCellDef="let row" mat-cell> {{ row.caseStatus }}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.CaseManager">
      <th *matHeaderCellDef mat-header-cell> Case Manager</th>
      <td *matCellDef="let row" mat-cell> {{ row.caseManager }}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.ElapsedDays">
      <th *matHeaderCellDef mat-header-cell> Elapsed Days</th>
      <td *matCellDef="let row" mat-cell>
        <ng-container *ngIf="row.caseStatus === caseStatus.Open">
          {{ row.startDate | timeElapsedFromNow: true }}
        </ng-container>
      </td>
    </ng-container>
    
    <!--Expanded Section -->
    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="casedTableDisplayedColumns.length">
        <div class="row-detail-container"
             [@detailExpand]="row == caseExpandedRow ? 'expanded' : 'collapsed'">
          <b>Created By: </b>{{ row.createdBy }}<br>
          <b>Created Date: </b>{{ row.created | date: dateTimeFormat }}<br>
          <b>Updated By: </b>{{ row.updatedBy }}<br>
          <b>Updated Date: </b>{{ row.updated | date: dateTimeFormat }}<br>
        </div>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="casedTableDisplayedColumns;"></tr>
    <tr mat-row *matRowDef="let row; columns: casedTableDisplayedColumns;" class="row"
        [class.expanded-row]="caseExpandedRow == row"
        (click)="caseExpandedRow = caseExpandedRow === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
  </table>
  
  <mat-paginator #casePaginator [pageIndex]="0"
                 [pageSize]="caseTableControl.pageSize"
                 [pageSizeOptions]="caseTableControl.pageSizeOptions"
                 [length]="caseTableControl.length"
                 (page)="pageChanged($event)">
  </mat-paginator>
</div>
